import React from 'react';
import { CustomDivider } from './SectionDivider.styles';

const SectionDivider = () => {
  return <CustomDivider />;
};

export default SectionDivider;
